import { type FC, type PropsWithChildren, useEffect, useMemo, useState } from 'react';

import { GuestAuthContext } from '../../../modules/context/guestAuthContext';
import { useMutationRequest, useRequest } from '../../../modules/hooks';

interface generateAuthTokenResponse {
  token: string;
  expireDate: string;
}

export const GuestAuthProvider: FC<PropsWithChildren> = ({ children }) => {
  const [guestToken, setGuestToken] = useState<string>('');
  const guestEndpoint = 'v1/auth/guest-auth';

  const [{ data, loading, error }, generateAuthToken] =
    useMutationRequest<generateAuthTokenResponse>(
      guestEndpoint,
      'post',
      {},
      { cacheResponse: true },
    );

  useEffect(() => {
    if (!data) return;

    setGuestToken(data.result.token);
  }, [data]);

  const packageContext = useMemo(() => {
    return { token: guestToken, generateAuthToken, loading, error };
  }, [guestToken, generateAuthToken, loading, error]);

  return (
    <GuestAuthContext.Provider value={packageContext}>
      {children}
    </GuestAuthContext.Provider>
  );
};
